// Punta Tech — App entry. Composes all sections in the order from the design
// (Claude Design project 019ddb2b-9049-7989-bd67-d698794d26b1, file "Punta Tech.html").
import { ACCENT } from "./theme.js";
import { Divider } from "./components/primitives.jsx";
import { Nav } from "./components/Nav.jsx";
import { Hero } from "./components/Hero.jsx";
import { LogoStrip } from "./components/LogoStrip.jsx";
import { Pain } from "./components/Pain.jsx";
import { Services } from "./components/Services.jsx";
import { Architecture } from "./components/Architecture.jsx";
import { About } from "./components/About.jsx";
import { Certifications } from "./components/Certifications.jsx";
import { Process } from "./components/Process.jsx";
import { Cases } from "./components/Cases.jsx";
import { Testimonials } from "./components/Testimonials.jsx";
import { Stack } from "./components/Stack.jsx";
import { FAQ } from "./components/FAQ.jsx";
import { LeadForm } from "./components/LeadForm.jsx";
import { Footer } from "./components/Footer.jsx";

export function App() {
  return (
    <div style={{ background: "#0a0a0a", minHeight: "100vh", color: "#fff" }}>
      <Nav accent={ACCENT} />
      <Hero accent={ACCENT} />
      <LogoStrip accent={ACCENT} />
      <Pain accent={ACCENT} />
      <Divider accent={ACCENT} />
      <Services accent={ACCENT} />
      <Divider accent={ACCENT} />
      <Architecture accent={ACCENT} />
      <Divider accent={ACCENT} />
      <About accent={ACCENT} />
      <Certifications accent={ACCENT} />
      <Divider accent={ACCENT} />
      <Process accent={ACCENT} />
      <Divider accent={ACCENT} />
      <Cases accent={ACCENT} />
      <Divider accent={ACCENT} />
      <Testimonials accent={ACCENT} />
      <Divider accent={ACCENT} />
      <Stack accent={ACCENT} />
      <Divider accent={ACCENT} />
      <FAQ accent={ACCENT} />
      <Divider accent={ACCENT} />
      <LeadForm accent={ACCENT} />
      <Footer accent={ACCENT} />
    </div>
  );
}
